import { client } from "../client/client";

export const uploadImage = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await client.post("/file-upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const uploadMultiImages = async (files) => {
  try {
    const formData = new FormData();

    for (const file of files) {
      formData.append("files", file);
    }

    const response = await client.post("file-upload/multiple", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
